export const MAX_OPTIONS_UNTIL_VIRTUALIZATION = 50;

/**
 * The default height of an option. This is used for calculating styles and in virtualization.
 */
export const DEFAULT_ITEM_HEIGHT = 40;
//# sourceMappingURL=selectConstants.js.map